// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const RemoveCircle: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" enableBackground="new 0 0 24 24" xmlSpace="preserve" fill="currentColor">
<path fillRule="evenodd" clipRule="evenodd" d="M12,0.5C5.65,0.5,0.5,5.65,0.5,12S5.65,23.5,12,23.5S23.5,18.35,23.5,12
	S18.35,0.5,12,0.5z M17.75,13.15H6.25v-2.3h11.5V13.15z"/>
</svg>;
};

export default React.memo(RemoveCircle);
